"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieAsArray = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _ramda = require("ramda");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var array2Cookie = JSON.stringify;
var createCookieShape = function createCookieShape(array, timestamp) {
  return {
    array: array,
    timestamp: timestamp
  };
};
var parseCookie = JSON.parse;
var CookieAsArray = exports.CookieAsArray = /*#__PURE__*/function () {
  function CookieAsArray(name, expiredTimestamp) {
    _classCallCheck(this, CookieAsArray);
    var cookie = _jsCookie.default.get(name);
    var _ref = cookie ? parseCookie(cookie) : createCookieShape([], null),
      array = _ref.array,
      timestamp = _ref.timestamp;
    this.array = array;
    this.name = name;
    this.timestamp = timestamp || expiredTimestamp;
  }
  return _createClass(CookieAsArray, [{
    key: "commit",
    value: function commit() {
      _jsCookie.default.set(this.name, array2Cookie(createCookieShape(this.array, this.timestamp)), {
        expires: (0, _moment.default)(this.timestamp, 'X').toDate()
      });
      return this;
    }
  }, {
    key: "getArray",
    value: function getArray() {
      return this.array;
    }
  }, {
    key: "push",
    value: function push(value) {
      this.array.push(value);
      return this;
    }
  }, {
    key: "remove",
    value: function remove(value) {
      this.array = (0, _ramda.without)([value], this.array);
      return this;
    }
  }]);
}();